module.exports = __webpack_public_path__ + "static/mpsk-logo-d7dd7d03f71ab5ee12ff0b833aee36c7.jpeg";